import { GzEasmGenericTopDataWebComponent } from './component/GzEasmGenericTopDataWebComponent';

export { GzEasmGenericTopDataWebComponent };
